const SKIPPED_SESSION_KEY = "emergency-contacts-skipped"

export function markEmergencyContactsSkippedThisSession() {
  sessionStorage.setItem(SKIPPED_SESSION_KEY, "true")
}

export function hasSkippedEmergencyContactsThisSession(): boolean {
  return sessionStorage.getItem(SKIPPED_SESSION_KEY) === "true"
}

export function clearEmergencyContactsSkippedSession() {
  sessionStorage.removeItem(SKIPPED_SESSION_KEY)
}
